import React from "react";

export const Interests = () => {
  return (
    <div className="interests">
      <h4 className="interests-title">Interests</h4>
      <p className="content">
        You can find me posting acoustic covers on Instagram & YouTube whenever
        I get a chance to sing. If you're interested in sports discussion, let's
        talk over a cup of coffee. I do love travelling as well.
      </p>
    </div>
  );
};
